export default __webpack_public_path__ + "static/chatting-3ce307e7d16bf2c5dad3fb3357b212ec.png";